import React, { useEffect } from "react";
import * as Styles from "../common/styles/TradeInAem";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import { getInternalLink } from "../../../utils/navUtils";
import { TradeInAemLabel } from "../../../utils/labels";
import VehicleDetailsResult from "./VehicleDetailsResult";
import VehicleDetailsTextField from "./VehicleDetailsTextField";
import VehicleDetailsRadioButton from "./VehicleDetailsRadioButton";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { TradeInAemDetailFormItemType } from "../../../utils/constants";
import VehicleDetailsCheckbox from "./VehicleDetailsCheckbox";
import useVehicleDetailsContainer from "../../../hooks/vehicle-details/useVehicleDetailsContainer";
import { trackStepVehicleDetails } from "../../../utils/tracking";
import useVehicleDetailsDateValidity from "../../../hooks/vehicle-details/useVehicleDetailsDateValidity";
import VehicleDetailsDropdown from "./VehicleDetailsDropdown";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { useDispatch } from "../../../../shared-logic/redux/store";
import { showBackCtaOnStepComponent } from "../../../utils/utils";

const VehicleDetailsContainer = (): JSX.Element => {
    const csl = useTradeInCsl();
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const formItems = useTradeInAemSelector((state) => state.tradeInAemVehicleDetails.formItems);
    const searchType = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchType);

    const prevStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "prev");
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");

    const { showRequiredErrors, confirmClick, sortedFormItemKeys } = useVehicleDetailsContainer(nextStep);
    const vehicleDateData = useVehicleDetailsDateValidity();
    const trackingParams = useTrackingParams();

    useEffect(() => {
        trackStepVehicleDetails(trackingParams, searchType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styles.Main>
            <Styles.Container>
                <TradeInAemLabel label="tradeInAemVehicleDetailsResultTitle" />
                <VehicleDetailsResult />
                {sortedFormItemKeys.map((formItemKey) => {
                    const formItem = formItems[formItemKey];
                    switch (formItem.type) {
                        case TradeInAemDetailFormItemType.Text:
                        case TradeInAemDetailFormItemType.Number:
                        case TradeInAemDetailFormItemType.Mileage:
                            return (
                                <VehicleDetailsTextField
                                    key={formItemKey}
                                    formItem={formItem}
                                    formItemKey={formItemKey}
                                    showRequiredError={showRequiredErrors}
                                />
                            );

                        case TradeInAemDetailFormItemType.Year:
                        case TradeInAemDetailFormItemType.Month: {
                            if (vehicleDateData) {
                                return (
                                    <VehicleDetailsDropdown
                                        key={formItemKey}
                                        formItem={formItem}
                                        formItemKey={formItemKey}
                                        showRequiredError={showRequiredErrors}
                                        range={vehicleDateData.ranges}
                                        selectedYear={vehicleDateData.selectedYear}
                                    />
                                );
                            } else {
                                return (
                                    <VehicleDetailsTextField
                                        key={formItemKey}
                                        formItem={formItem}
                                        formItemKey={formItemKey}
                                        showRequiredError={showRequiredErrors}
                                    />
                                );
                            }
                        }

                        case TradeInAemDetailFormItemType.Radio:
                            return (
                                <VehicleDetailsRadioButton
                                    key={formItemKey}
                                    formItem={formItem}
                                    formItemKey={formItemKey}
                                    showRequiredError={showRequiredErrors}
                                />
                            );

                        case TradeInAemDetailFormItemType.Checkbox:
                            return (
                                <VehicleDetailsCheckbox
                                    key={formItemKey}
                                    formItem={formItem}
                                    formItemKey={formItemKey}
                                    showRequiredError={showRequiredErrors}
                                />
                            );

                        default:
                            return null;
                    }
                })}
                <Styles.ButtonWrapper stretchMobile spaceBetween>
                    {showBackCtaOnStepComponent(currentStep, csl.enabledNavSteps) && (
                        <Button.Link m={0} as="a" href={prevStep.href} onClick={prevStep.onClick} hasIcon>
                            <IconWrapper>
                                <Icon variant="arrowLeft" />
                            </IconWrapper>
                            <Text.Button>
                                <TradeInAemLabel label="tradeInAemBack" />
                            </Text.Button>
                        </Button.Link>
                    )}
                    <Button.Primary
                        mx={0}
                        mb={{ _: 2, md: 0 }}
                        width={{ _: 1, md: "auto" }}
                        as="a"
                        href={nextStep.href}
                        onClick={confirmClick}
                    >
                        <Text.Button>
                            <TradeInAemLabel label="tradeInAemConfirm" />
                        </Text.Button>
                    </Button.Primary>
                </Styles.ButtonWrapper>
            </Styles.Container>
        </Styles.Main>
    );
};
export default VehicleDetailsContainer;
